import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const navigate = useNavigate();


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickNewManagement = () => {
        
        // navigate si funcionó
        navigate('/administrador-arrendamientos-form')
    }

    const handleClickInfoManagement = (idgestion, openingmode) => {
        
        // navigate si funcionó
        navigate(`/administrador-arrendamientos-form/edit/${idgestion}`)
    }

    const handleClickDeleteManagement = (idgestion) => {

        const { fetchAllManagements } = FetchData
        const { executeFetchAllManagements } = fetchAllManagements

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/leases/mgmt-management/management/${idgestion}`)
                .then(({data}) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllManagements()
                    }
                    
                }).catch(e => {
                    console.log(e)
                    Swal.fire({
                        icon: 'error',
                        title: 'Ocurrio un problema',
                        text: 'Comuniquese con mantenimiento'
                    })
                })
            }
        })
    }


  

    return Object.freeze({
        handleClickNewManagement,
        handleClickInfoManagement,
        handleClickDeleteManagement
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}